import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { PieChart, Doughnut, Bar, Column } from './charts';

function Repos({ repos }) {
  let languages = repos.reduce((total, item) => {
    const { language, stargazers_count } = item;
    if (!language) return total;

    if (!total[language]) {
      total[language] = { label: language, value: 1, stars: stargazers_count };
    } else {
      total[language] = {
        ...total[language],
        value: total[language].value + 1,
        stars: total[language].stars + stargazers_count,
      };
    }

    return total;
  }, {});

  languages = Object.values(languages)
    .sort((a, b) => {
      return b.value - a.value;
    })
    .slice(0, 5);

  const StarsPerLang = languages.map((lang) => {
    return { label: lang.label, value: lang.stars };
  });

  const mostPoular = repos
    .map((item) => {
      const { name, stargazers_count } = item;
      return { label: name, value: stargazers_count };
    })
    .sort((a, b) => {
      return b.value - a.value;
    })
    .slice(0, 5);

  const mostForked = repos
    .map((item) => {
      const { name, forks_count } = item;
      return { label: name, value: forks_count };
    })
    .sort((a, b) => {
      return b.value - a.value;
    })
    .slice(0, 5);

  return (
    <section className='section'>
      <Wrapper className='section-center'>
        <PieChart data={languages} />
        <Bar data={mostForked} />
        <Doughnut data={StarsPerLang} />
        <Column data={mostPoular} />
      </Wrapper>
    </section>
  );
}

const Wrapper = styled.div`
  display: grid;
  justify-items: center;
  gap: 2rem;
  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1200px) {
    grid-template-columns: 2fr 3fr;
  }

  div {
    width: 100% !important;
  }
  .fusioncharts-container {
    width: 100% !important;
  }
  svg {
    width: 100% !important;
    border-radius: var(--radius) !important;
  }
`;

const mapStateToProps = (store) => {
  return { ...store };
};

export default connect(mapStateToProps)(Repos);
